import toastr from 'toastr';
import 'toastr/build/toastr.css';
import config from './index.config';
import routerConfig from './index.route';
import runBlock from './index.run';
import AuthInterceptorService from './authInterceptorService';
import MenuController from './menuController';
import LoginController from './login/LoginController';
import HomeController from './HomeController';
import LagerController from './artikel/lagerController';
import ArtikelController from './artikel/artikelController';
import AnfrageController from './anfragen/anfrageController';
import ShowErrors from './components/showErrors';
import VossIso from './components/VossIso';
import VossArtikelBild from './components/VossArtikelBild';
import KundenController from './kunden/kundenController';
import KundeController from './kunden/kundeController';
import RechnungenController from './rechnungen/rechnungenController';
import RechnungController from './rechnungen/rechnungController';
import RechnungNeuController from './rechnungen/rechnungNeuController';

import './natives.js';

const app = {
};

angular.module('vossWebApp', ['ngResource', 'ngRoute', 'ngSanitize', 'ui.bootstrap', 'LocalStorageModule', 'infinite-scroll', 'pascalprecht.translate'])
  .config(config)
  .config(routerConfig)
  .provider('AuthInterceptorService', AuthInterceptorService)
  .directive('showErrors', () => new ShowErrors())
  .directive('vossIso', () => new VossIso())
  .directive('vossArtikelBild', () => new VossArtikelBild())
  .controller('HomeController', HomeController)
  .controller('LoginController', LoginController)
  .controller('MenuController', MenuController)
  .controller('LagerController', LagerController)
  .controller('ArtikelController', ArtikelController)
  .controller('AnfrageController', AnfrageController)
  .controller('KundenController', KundenController)
  .controller('KundeController', KundeController)
  .controller('RechnungNeuController', RechnungNeuController)
  .controller('RechnungController', RechnungController)
  .controller('RechnungenController', RechnungenController)
  .run(runBlock);

window.getScopeByController = function (controller) {
  return angular.element('[ng-controller="' + controller + ' as vm"]').scope();
};

toastr.options.timeOut = 3000;
toastr.options.positionClass = 'toast-top-right';
toastr.options.preventDuplicates = true;
toastr.options.progressBar = true;

window.app = app;
window.toastr = toastr;

export default app;



// WEBPACK FOOTER //
// ./app/index.js